import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  fetchFirstActiveCreditCoupon,
  setCreditCouponCode,
  applyCreditCoupon,
  removeAppliedCreditCoupon,
} from '../../../../actions/purchaseActions';
import { InfoIcon } from '../../../../assets/icons/Info.icon';
import { CheckCircleIcon } from '../../../../assets/icons/CheckCircle.icon';

import './styles.css';

const BoxCreditCoupon = ({
  creditCoupon,
  purchaseSummary,
  fetchFirstActiveCreditCoupon,
  applyCreditCoupon,
  removeAppliedCreditCoupon,
  setCreditCouponCode,
}) => {
  const applied = creditCoupon.applied || false;

  useEffect(() => {
    fetchFirstActiveCreditCoupon();
  }, [fetchFirstActiveCreditCoupon]);

  const handleApplyCoupon = () => {
    if (creditCoupon.code) {
      applyCreditCoupon(creditCoupon.code);
    }
  };

  const handleRemoveAppliedCreditCoupon = () => {
    if (applied) {
      removeAppliedCreditCoupon();
    }
  };

  if (creditCoupon.code === null) {
    return null;
  }

  const couponCode = creditCoupon.code || '';
  const creditAmount = creditCoupon.creditAmount || 0;

  return (
    <div className="credit-balance-wrapper">
      <div className="credit-balance">
        <section className="available-coupons">
          <h2 className="credit-balance__title">Crédito disponível</h2>

          <article className="credit-balance__card">
            <div className="credit-balance__badge">
              Saldo disponível
              <InfoIcon />
            </div>

            <div className="credit-balance__form">
              <input
                type="text"
                name="credit_coupon"
                className="credit-balance__input"
                value={couponCode}
                onChange={(e) => setCreditCouponCode(e.target.value)}
                disabled={applied}
              />
              {applied ? (
                <button type="button" className="btn remove" onClick={handleRemoveAppliedCreditCoupon}>
                  Remover
                </button>
              ) : (
                <button type="button" className="btn" onClick={handleApplyCoupon}>
                  Usar
                </button>
              )}
            </div>

            {creditCoupon.error ? (
              <b className="coupon-card__error">Cupom inválido ou expirado</b>
            ) : (
              <p className="coupon-card__description">
                Crédito de{' '}
                <strong>
                  {creditAmount.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </strong>
              </p>
            )}
          </article>
        </section>
      </div>

      {applied && (
        <div className="credit-balance-feedback">
          <div className="credit-balance-feedback__label">
            <CheckCircleIcon /> Crédito aplicado
          </div>
          <div>
            {purchaseSummary.creditCouponAmountUsed.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  creditCoupon: state.purchase.creditCoupon,
  purchaseSummary: state.purchase.purchaseSummary,
});

const mapDispatchToProps = {
  fetchFirstActiveCreditCoupon,
  setCreditCouponCode,
  applyCreditCoupon,
  removeAppliedCreditCoupon,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BoxCreditCoupon));



// WEBPACK FOOTER //
// ./src/components/purchase/purchase_description/box_credit_coupon/index.jsx